/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Chillpay
 */
export class Chillpay {
    /**
     *
     * @type {string}
     * @memberof Chillpay
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Chillpay
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Chillpay
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Chillpay
     */
    apiKey: string;
    /**
     *
     * @type {string}
     * @memberof Chillpay
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Chillpay
     */
    merchantCode: string;
    /**
     *
     * @type {boolean}
     * @memberof Chillpay
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Chillpay
     */
    autoApprove: boolean;
}
